import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { TrendingUp, TrendingDown, AlertCircle } from 'lucide-react';
export function StakesSection() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section className="relative py-16 sm:py-20 md:py-24 px-5 sm:px-6 bg-black" data-id="element-2879" data-mp="1mwdhfpf7ggfr">
      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 30
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto text-center" data-id="element-2880" data-mp="20wo7iq8oxqzv">
        <div className="mb-8 sm:mb-12" data-id="element-2881" data-mp="2amzbudwae27a">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-stone-100 mb-6 sm:mb-8" style={{
          fontFamily: 'Cinzel, serif'
        }} data-id="element-2882" data-mp="2alxxo0jz4zlc">
            The Cost of Inaction
          </h2>
          <p className="text-lg sm:text-xl text-stone-400 max-w-2xl mx-auto" data-id="element-2883" data-mp="2jl303hynpd2s">
            Every day you wait is another day your biology is operating below
            its potential.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-12 sm:mb-16" data-id="element-2884" data-mp="2bg3sm402dt84">
          <div className="bg-red-950/20 border border-red-900/30 p-6 sm:p-8 rounded-xl" data-id="element-2885" data-mp="2gewwr5tgo7vm">
            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-2886" data-mp="2lam0zmgfecy9">
              <TrendingDown className="w-10 h-10 sm:w-12 sm:h-12 text-red-500" data-id="element-2887" data-mp="2qc1ij4jea1bw" />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-red-400 mb-3 sm:mb-4" data-id="element-2888" data-mp="2ubk504qv6kgu">
              Without This Knowledge
            </h3>
            <ul className="space-y-3 sm:space-y-4 text-left text-stone-300 text-sm sm:text-base" data-id="element-2889" data-mp="2z9lnanggufr9">
              <li className="flex items-start gap-3" data-id="element-2890" data-mp="344hqmjr5kpjo">
                <span className="text-red-500 font-bold" data-id="element-2891" data-mp="391rg1zejl17i">✕</span>
                <span data-id="element-2892" data-mp="3e0ktjrttws7o">Guessing with your health</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-2893" data-mp="3e2fdb2td6ea6">
                <span className="text-red-500 font-bold" data-id="element-2894" data-mp="3i1eh2k3d0501">✕</span>
                <span data-id="element-2895" data-mp="3hztoh00luw4t">Wasting money on ineffective supplements</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-2896" data-mp="1ivbpmf3qtsfu">
                <span className="text-red-500 font-bold" data-id="element-2897" data-mp="1dze845gqug1h">✕</span>
                <span data-id="element-2898" data-mp="1rpq3cd8mkuwu">Following outdated medical advice</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-2899" data-mp="1rrkn3o85ugzc">
                <span className="text-red-500 font-bold" data-id="element-2900" data-mp="1mxyhuh4btfdk">✕</span>
                <span data-id="element-2901" data-mp="21nnmwnfji3j4">Continued decline and aging</span>
              </li>
            </ul>
          </div>

          <div className="bg-green-950/20 border border-green-900/30 p-6 sm:p-8 rounded-xl" data-id="element-2902" data-mp="1wp2v9cecss6a">
            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-2903" data-mp="2aoc0xi4xo3w0">
              <TrendingUp className="w-10 h-10 sm:w-12 sm:h-12 text-green-500" data-id="element-2904" data-mp="2anst4u8zyvvp" />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-green-400 mb-3 sm:mb-4" data-id="element-2905" data-mp="26ns98u34psh9">
              With PSI PRO
            </h3>
            <ul className="space-y-3 sm:space-y-4 text-left text-stone-300 text-sm sm:text-base" data-id="element-2906" data-mp="c9938hjdp6uh">
              <li className="flex items-start gap-3" data-id="element-2907" data-mp="25atrdm9zkcb">
                <span className="text-green-500 font-bold" data-id="element-2908" data-mp="25kkj3f59vj2">✓</span>
                <span data-id="element-2909" data-mp="66w3iq3ijiia">Precision control of your biology</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-2910" data-mp="3okvhnacmbdye">
                <span className="text-green-500 font-bold" data-id="element-2911" data-mp="3okddzsnmlxgg">✓</span>
                <span data-id="element-2912" data-mp="3tix5e8kzo1g7">Access to cutting-edge protocols</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-2913" data-mp="3empll9dht21g">
                <span className="text-green-500 font-bold" data-id="element-2914" data-mp="3el4p3e7mb90y">✓</span>
                <span data-id="element-2915" data-mp="3jmlmgzqw8dcs">Direct guidance from experts</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-2916" data-mp="35m16scg9yxni">
                <span className="text-green-500 font-bold" data-id="element-2917" data-mp="35nlx1pvk3ufk">✓</span>
                <span data-id="element-2918" data-mp="3alvvc9ckvb5e">Regeneration and optimization</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-amber-950/20 border border-amber-500/30 p-6 sm:p-8 rounded-lg" data-id="element-2919" data-mp="13uxr38rj2sw3">
          <div className="flex items-start gap-4" data-id="element-2920" data-mp="18s6999coewxc">
            <AlertCircle className="w-6 h-6 sm:w-8 sm:h-8 text-amber-500 flex-shrink-0 mt-1" data-id="element-2921" data-mp="34wdsr08uhlov" />
            <div className="text-left" data-id="element-2922" data-mp="2zxj9xyavnx4r">
              <p className="text-lg sm:text-xl font-bold text-amber-400 mb-2" data-id="element-2923" data-mp="2zykl02rw8jmh">
                Remember:
              </p>
              <p className="text-stone-300 text-base sm:text-lg" data-id="element-2924" data-mp="2uwmxuxgdh4o9">
                Every day you wait is another day your biology keeps operating
                below its potential.
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}